import React from 'react';

/**
 * Stylized "ENEAFLIX" wordmark: ENEA in orange (#FF6700, bold) + FLIX
 * in white (#EAEAEA, bold italic). Use anywhere the brand name needs to
 * be displayed on a dark background. Inherits font-size from parent so
 * it slots into any heading or link.
 */
export const EneaflixWordmark = ({ className = '' }) => (
  <span className={`inline-flex items-baseline ${className}`}>
    <span className="font-bold text-accent-orange">ENEA</span>
    <span className="font-bold italic text-[#EAEAEA]">FLIX</span>
  </span>
);

export default EneaflixWordmark;
